/**
 * [ File :: B_Util.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/util/B_Util.js
 * @목적 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import {isDist} from 'canvas/base/dev/util/B_Config';

const B_Util = (function () {

	return class {

		// @DES :: dist 상태값에 따라 프린트 처리하는 함수
		static print(str) {
			if (!isDist()) console.log(str);
		}

		// @DES :: dist 상태값에 따라 알림 처리하는 함수
		static alert(str) {
			if (!isDist()) alert(str);
		}

		// @DES :: dist 상태값에 따라 프롬프트 처리하는 함수
		static prompt(str) {
			if (!isDist()) return prompt(str);
		}

		/**
		 * @DES :: 타입에 따른 랜덤한 아이디값 전달 함수
		 * @O.P :: rtn {str}
		 * @S.E ::
		 */
		static getRandom() {
			return (Math.random() * (1 << 30)).toString(16).replace('.', '');
		}

		/**
		 * @DES :: 타입에 따른 랜덤한 아이디값 전달 함수
		 * @IP1 :: type[str]
		 * @O.P :: rtn[str]
		 * @S.E ::
		 */
		static getRandomID(type) {
			let randomId = (Math.random() * (1 << 30)).toString(16).replace('.', '');
			return type ? type + '-' + randomId : randomId;
		}

		// @DES :: JSON 키에 의해서 정렬하기
		static jsonSortByKey(json) {
			let keys = [], rtn = {};
			for (let key in json) {
				if (json.hasOwnProperty(key)) keys.push(key);
			}
			keys.sort();
			for (let i = 0; i < keys.length; i++) {
				let key = keys[i];
				rtn[key] = json[key];
			}
			return rtn;
		}

		// @DES :: Object Clone
		static clone(obj) {
			return JSON.parse(JSON.stringify(obj));
		}

		// @DES :: Check Speed
		static checkSpeed(speed) {
			if(typeof speed !== 'number' || (speed < 1 || speed > 10)) {
				return false;
			} else {
				return true;
			}
		}

		/**
		 * @DES :: Protected 객체 던지기
		 * @IP1 :: obj {obj}
		 * @O.P :: str {str}
		 * @S.E ::
		 */
		static getProtected(obj) {
			// console.log('================================================', obj._id);
			try {
				let scope = obj;    	      // [#] 스코프 저장소
				let result = function () {};  // [#] protected 객체

				// [#] Object down to top ( child -> parent -> object )
				for (let o = scope; o != Object.prototype; o = Object.getPrototypeOf(o)) {
					for (let name of Object.getOwnPropertyNames(o)) {
						if (name == 'constructor') continue; // [#] 생성자 제외
						if (name[0] == '_') continue;        // [#] '_' protected 제외
						if (!result.prototype[name]) setProperty(scope, o, result, name);
					}

					function setProperty(scope, o, result, name) {
						let preDescriptor = Object.getOwnPropertyDescriptor(o, name);
						let newDescriptor = {};
						if (preDescriptor.get || preDescriptor.set) {
							// [#] CASE01 - used getter & setter
							if (preDescriptor.get) result.prototype.__defineGetter__(name, function () {
								return scope[name]
							});
							if (preDescriptor.set) result.prototype.__defineSetter__(name, function (arg) {
								return scope[name] = arg
							});
							return;
						}
						else {
							// [#] CASE02 - property & prototype (분기처리)

							// [*] number & string - 객체 참조 (get & set 이용)
							if (
								(typeof scope[name] !== 'object' && typeof scope[name] !== 'function')
								||
								scope[name] === null
							) {
								result.prototype.__defineGetter__(name, function () {
									return scope[name]
								});
								result.prototype.__defineSetter__(name, function (arg) {
									return scope[name] = arg
								});
								return;
							}

							// [*] Function - scope 유지
							if (scope[name] instanceof Function) {
								result.prototype[name] = function (...arg) {
									return scope[name](...arg)
								};
								return;
							}

							// [*] Object - 객체 참조
							else {
								result.prototype[name] = scope[name];
								return;
							}
						}
					}
				}
				return new result();
			} catch (e) {
				B_Util.print('[코드모스] => getProtected in B_Util - ' + e);
			}
		}

		/**
		 * @DES :: 모든 프로토타입에서 요청한 속성 찾기
		 * @IP1 :: property {obj}
		 * @IP2 :: name {str}
		 * @O.P :: desciptor {json}
		 * @S.E :: Object.getOwnPropertyDescriptor 연계기능
		 */
		static getOwnPrototypeDescriptor(property, name) {
			let desciptor = Object.getOwnPropertyDescriptor(property, name);
			if (desciptor) {
				return desciptor;
			} else {
				if (property.__proto__) {
					return this.getOwnPrototypeDescriptor(property.__proto__, name)
				} else {
					return undefined;
				}
			}
		}

		/**
		 * @DES :: 객체에 prototype에서 Symbol Property 얻기
		 * @IP1 :: obj {obj}
		 * @O.P :: str {str}
		 * @S.E ::
		 */
		static getPropertySymbol(obj, str) {
			let symbols = Object.getOwnPropertySymbols(obj);
			let symbol = false;
			for (let i = 0; i < symbols.length; i++) {
				if (symbols[i].toString().indexOf(str)) symbol = symbols[i];
			}
			return symbol;
		}

		/**
		 * @DES :: 객체에 prototype에서 Symbol Property 얻기
		 * @IP1 :: obj {obj}
		 * @O.P :: str {str}
		 * @S.E ::
		 */
		static getPrototypeSymbol(obj, str) {
			let symbol = this.getPropertySymbol(obj, str);
			if (symbol) {
				return symbol;
			} else {
				if (obj.__proto__)
					return this.getPrototypeSymbol(obj.__proto__, str);
				else
					return undefined;
			}
		}

		/**
		 * @DES :: 클래스에 요청 prop의 get & set 추가하기
		 * @IP1 ::
		 * @O.P ::
		 * @S.E ::
		 */
		static manageGetAndSet(cname, props) {
			try {
				for (let key in props) {
					// [#] class 내부선언 제외
					if (Object.getOwnPropertyNames(cname.prototype).indexOf(key) == -1) {
						// [#] private 제외
						if (key[1] != '_') {
							Object.defineProperty(cname, key, {
								get: function () { return props[key] },
								set: function (p) { props[key] = p },
								enumerable: true,
								configurable: true
							});
						}
					}
				}
			} catch (e) {
				console.log(e);
			}
		}

		/**
		 * @DES :: 캔버스 Dom 만들기
		 * @IP1 :: domId {str}
		 * @IP2 :: type {str}
		 * @IP3 :: w {num}
		 * @IP4 :: h {num}
		 * @IP5 :: z {num}
		 * @IP6 :: p {num}
		 * @O.P :: CANVAS_DOM {dom}
		 * @S.E :: 특이사항없음
		 */
		static appendCanvasDom(canvasWrapper, domId, type, w, h, z, p) {

			// [#] CANVAS_DOM
			const CANVAS_DOM = document.createElement('div');
			CANVAS_DOM.setAttribute("id", domId);
			CANVAS_DOM.setAttribute("type", type);
			CANVAS_DOM.style['visibility'] = "hiddle";
			CANVAS_DOM.style['position'] = "absolute";
			CANVAS_DOM.style['z-index'] = z;
			CANVAS_DOM.style['width'] = w + "px";
			CANVAS_DOM.style['height'] = h + "px";
			CANVAS_DOM.style['padding'] = p + "px";
			CANVAS_DOM.style['display'] = 'flex';
			CANVAS_DOM.style['justify-content'] = 'center';
			CANVAS_DOM.style['align-items'] = 'center';

			// [#] CANVAS_DOM_CONTENTS (vertical center 만들기 위함)
			// const CANVAS_DOM_CONTENTS = document.createElement('div');
			// CANVAS_DOM_CONTENTS.setAttribute("id", domId + '-contents');
			// CANVAS_DOM_CONTENTS.style['position'] = "relative";
			// CANVAS_DOM_CONTENTS.style['text-align'] = "center";
			// CANVAS_DOM_CONTENTS.style['top'] = "50%";
			// CANVAS_DOM_CONTENTS.style['transform'] = "translateY(-50%)";
			// CANVAS_DOM.appendChild(CANVAS_DOM_CONTENTS);

			// [#] CANVAS_WRAPPER에 추가 (앞에서부터추가)
			// canvasWrapper.appendChild(CANVAS_DOM); (X)
			canvasWrapper.insertBefore(CANVAS_DOM, canvasWrapper.firstChild);

			return CANVAS_DOM;
		}

		/**
		 * [ Function :: loadCss ]
		 *
		 * @DES :: CSS파일을 JS파일에서 동적으로 추가하는 함수
		 * @IP1 :: filename {str}
		 * @O.P :: null
		 * @S.E :: 특이사항없음
		 */
		static loadCss(filename) {
			const fileref = document.createElement("link");
			fileref.setAttribute("rel", "stylesheet");
			fileref.setAttribute("type", "text/css");
			fileref.setAttribute("href", filename);
			if (typeof fileref !== "undefined") document.getElementsByTagName("head")[0].appendChild(fileref);
		}

		static getRandomInt (start, end, exce) {
			const random = parseInt(Math.random() * (end - (start - 1))) + start
			return (typeof exce === 'number' && exce === random) || (Array.isArray(exce) && exce.indexOf(random) > -1)
				? B_Util.getRandomInt(start, end, exce)
				: random
		}
	}
}());

export default B_Util;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/util/B_Util.js